module.exports = __webpack_public_path__ + "static/media/16.bf03e321.jpg";